import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
 
@Component({
  selector: 'app-modals-scale',
  templateUrl: './modals-scale.component.html',
  styleUrls: ['./modals-scale.component.css']
})
export class ModalsScaleComponent { 
  observation: string = null;
  isApproved = false;
  constructor(
    public dialogRef: MatDialogRef<ModalsScaleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private spinner: NgxSpinnerService) {
  }
  onSubmit() {
    this.isApproved = true;
    const policy ={
      policyId: this.data.sendData.policyId,
      statusId: 4,
    };
    if (this.observation === '' || this.observation === undefined  || this.observation === null) {
      this.observation = null;
    } else {
      Object.assign(policy, {observation: this.observation});
    }
    this.dialogRef.close(policy);
    return;
  }
}